var render, staticRenderFns
import script from "./nav-bar-routes.vue?vue&type=script&lang=js"
export * from "./nav-bar-routes.vue?vue&type=script&lang=js"
import style0 from "./nav-bar-routes.vue?vue&type=style&index=0&id=12553a6a&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "12553a6a",
  null
  
)

export default component.exports